import ReactPlayer, { type ReactPlayerProps } from 'react-player/lazy'

interface Props extends ReactPlayerProps {}

export const VideoPlayer = (props: Props) => {
  return <ReactPlayer {...props} />
}
